<template>
    <div>
    <form @submit.prevent="searchAction">
    <!-- <el-row type="flex" :gutter="20" justify="end"> -->
    <el-row type="flex" :gutter="20">
        <el-col v-if="boardMst.categoryYn === 'Y'" :span="4">
            <div class="form-group">
              <label>분류</label>
              <el-select v-model="search.category" @change="searchAction">
                <el-option key="" value="" label="전체"></el-option>
                <el-option v-for="item in this.boardMst.categoryList"
                  :key="item.value" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
            </div>            
        </el-col>
        <el-col v-if="boardMst.writeAuthTy === 'NONE'" :span="3">
            <div class="form-group">
              <label>회원구분</label>
              <el-select v-model="search.memberTy" @change="searchAction">
                <el-option key="" value="" label="전체"></el-option>
                <el-option v-for="item in memberTyList"
                  :key="item.value" :label="item.text" :value="item.value">
                </el-option>
              </el-select>
            </div>            
        </el-col>

        <el-col v-if="boardMst.stateYn === 'Y'" :span="4">
            <div class="form-group">
              <label>상태</label>
              <el-select v-model="search.state" @change="searchAction">
                <el-option key="" value="" label="전체"></el-option>
                <el-option v-for="item in this.boardMst.stateList"
                  :key="item.value" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
            </div>            
        </el-col>
        <el-col :span="6">
            <div class="form-group">
              <label>검색 키워드</label>
              <el-input v-model="search.keyword" placeholder="제목/내용/작성자 검색"/>
            </div>            
        </el-col>
        <el-col :span="2">
            <div class="form-group">
              <label>리스트수</label>
              <el-select v-model="rows" @change="searchAction">
                <el-option key="10" value="10" />
                <el-option key="20" value="20" />
                <el-option key="30" value="30" />
                <el-option key="50" value="50" />
                <el-option key="100" value="100" />
              </el-select>
            </div>            
        </el-col>
        <el-col :span="3" v-if="(boardMst.writeAuthTy == 'ADMIN' && boardMst.isAdmin) || (boardMst.writeAuthTy !== 'ADMIN' && $store.state.account.userName)">
            <div class="form-group">
            <label>내가쓴 글만 보기</label>
            <el-switch
                class="mt-2"
                v-model="search.myYn"
                active-text="Yes"
                inactive-text="No"
                active-value="Y"
                inactive-value="N"
                @change="searchAction"
                >
            </el-switch>            
            </div>
        </el-col>
        <el-col :span="6">
            <div class="form-group">
                <label>&nbsp;</label>
                <div>
                <el-button native-type="submit" type="primary" icon="el-icon-search">검색</el-button>
                <el-button @click="resetForm" type="primary" icon="el-icon-refresh">초기화</el-button>
                </div>
            </div>
        </el-col>

    </el-row>
    </form>
    </div>
</template>

<script>

export default {
    props: {
        boardMst: { type: Object },
        searchParams: { type: Object },
    },
    created() {
        this.searchInit = {...this.search}
        this.search = {...this.search, ...this.searchParams}
    },
    methods: {
        searchAction() {
            // this.$emit('update:search', this.search);
            this.$emit('on-search', this.search );
        },
        resetForm() {
            this.search = {rows:this.search.rows, ...this.searchInit}
            this.searchAction();
        },        

    },
    computed: {
        rows: {
            get() {
                return this.search.rows
            },
            set(value) {
                window.localStorage.setItem('article.rows', value)
                this.search.rows = value
            }
        }
    },
    data() {
        return {

            search: {
                state: '',
                category: '',
                keyword: '',
                myYn: 'N',
                memberTy: '',
                rows: 10,
            },

            memberTyList: [{
                text:'정회원', value:'Y'
            },{
                text:'비회원', value:'N'
            }]

        }
    }

}

</script>